function classJoin(withConditions, withoutConditions) {
    var classes = [];
    var keys = Object.keys(withConditions);
    for (var i = 0, n = keys.length; i < n; i++) {
        var key = keys[i];
        if (withConditions[key]) {
            classes.push(key);
        }
    }
    if (withoutConditions) {
        classes = withoutConditions.concat(classes);
    }
    return classes.join(' ');
}
export { classJoin as default, };
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../node_modules/classjoin/es5-esm/index.js
// module id = V3ls
// module chunks = 10